// Desenho à mão livre nos canvas do prontuário (Locais dos sintomas e Exame complementar): cada movimento do mouse
// ou do dedo vira um trecho de linha desde o ponto anterior, sem os buracos que os pontinhos soltos deixavam

// A mesma espessura dos pontinhos de antes (arco de raio 1,5 com linha de 3 = 6 px de diâmetro)
export const DRAWING_LINE_WIDTH = 6

// Quantas cópias o Desfazer guarda. Cada uma é o desenho inteiro (cerca de 0,8 MB num canvas de 450 × 470), por isso o
// limite. Passando dele, a primeira cópia (o desenho como abriu) fica e sai a segunda: as duas alterações mais antigas
// passam a voltar juntas, e o último Desfazer continua chegando ao desenho como abriu
export const MAX_UNDO_STEPS = 30

// Posição de um evento do mouse ou de um dedo (Touch) em pixels do canvas. Desconta a borda e acompanha o canvas se o
// CSS mudar o tamanho dele na tela
export function getCanvasPoint(canvas, source) {
  const rect = canvas.getBoundingClientRect()
  const scaleX = canvas.clientWidth ? canvas.width / canvas.clientWidth : 1
  const scaleY = canvas.clientHeight ? canvas.height / canvas.clientHeight : 1

  return {
    x: (source.clientX - rect.left - canvas.clientLeft) * scaleX,
    y: (source.clientY - rect.top - canvas.clientTop) * scaleY,
  }
}

// O dedo com esse identifier numa lista de toques (TouchList ou array). A ordem da lista muda entre eventos, e a
// lista "touches" traz também dedos e palma fora do desenho, por isso o traço segue o dedo pelo identifier
export function findTouch(touches, identifier) {
  for (let index = 0; index < (touches?.length ?? 0); index += 1) {
    if (touches[index].identifier === identifier) return touches[index]
  }
  return undefined
}

// Linha do ponto anterior até o atual. Com os dois pontos iguais (clique ou toque sem arrastar), desenha só um ponto
export function drawSegment(context, from, to, color) {
  context.strokeStyle = color
  context.fillStyle = color
  context.lineWidth = DRAWING_LINE_WIDTH
  context.lineCap = 'round'
  context.lineJoin = 'round'
  context.beginPath()

  if (from.x === to.x && from.y === to.y) {
    context.arc(to.x, to.y, DRAWING_LINE_WIDTH / 2, 0, Math.PI * 2)
    context.fill()
    return
  }

  context.moveTo(from.x, from.y)
  context.lineTo(to.x, to.y)
  context.stroke()
}

// Guarda uma cópia do desenho antes de uma alteração, para o Desfazer
export function pushUndoSnapshot(history, canvas) {
  try {
    history.push(canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height))
  } catch {
    return // o getImageData falha em canvas sem tamanho (0 × 0) ou que não deixa ler os pixels: segue sem esse passo
  }
  if (history.length > MAX_UNDO_STEPS) history.splice(1, 1)
}

// true quando a cópia é igual ao desenho de agora (mesmo tamanho e mesmos pixels)
export function matchesCanvas(snapshot, canvas) {
  if (snapshot.width !== canvas.width || snapshot.height !== canvas.height) return false

  let current
  try {
    current = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data
  } catch {
    return false
  }
  const saved = snapshot.data
  if (saved.length !== current.length) return false
  for (let index = 0; index < saved.length; index += 1) {
    if (saved[index] !== current[index]) return false
  }
  return true
}

// Volta o desenho para a cópia mais recente. Devolve false quando não há nada para desfazer
export function undoLastChange(history, canvas) {
  const snapshot = history.pop()
  if (!snapshot) return false

  if (canvas.width !== snapshot.width || canvas.height !== snapshot.height) {
    canvas.width = snapshot.width
    canvas.height = snapshot.height
  }
  canvas.getContext('2d').putImageData(snapshot, 0, 0)
  return true
}
